import { Insights } from '../../types/Insights';
import { FC } from 'react';
import { Icons, LayoutCarousel, SingleMetric } from '@silverfort/sf-components';
import SecurityExposuresCard from './SecurityExposuresCard';
import PairedUserStatisticsCard from './PairedUserStatisticsCard';

type Props = {
    insights: Insights;
    isLoading: boolean;
};

const UserManagementInsights: FC<Props> = ({ insights, isLoading }) => {
    return (
        <div className="grid grid-cols-8 grid-rows-4 gap-3 h-50">
            <div className="col-span-2 row-span-2">
                <LayoutCarousel
                    title="Managed Users"
                    contentClassName="py-0 flex flex-1 flex-col justify-center [&]:items-start"
                    pages={
                        <div className="flex flex-row gap-2 px-2">
                            {isLoading ? (
                                <div className="h-6 w-[112px] animate-pulse rounded-sm bg-sf-gray-50"></div>
                            ) : (
                                <span className="text-21 font-bold font-sf-poppins">
                                    {insights?.totalProtectedUsers.toLocaleString()}
                                </span>
                            )}
                        </div>
                    }
                />
            </div>

            <div className="row-span-2 col-start-1 row-start-3 font-sf-poppins h-full">
                <SingleMetric
                    title="Recently Paired"
                    value={insights.newPairedDevices}
                    isLoading={isLoading}
                    iconRight={Icons.ArrowTrendUp}
                    iconClassName="text-sf-positive-600"
                />
            </div>

            <div className="row-span-2 col-start-2 row-start-3 font-sf-poppins h-full">
                <SingleMetric title="Recently Added" value={insights.newPairedUsers} isLoading={isLoading} />
            </div>

            <div className="col-span-2 row-span-4 col-start-3 row-start-1">
                <SecurityExposuresCard
                    insights={insights}
                    isLoading={isLoading}
                    isEmpty={(insights?.totalProtectedUsers ?? 0) === 0}
                />
            </div>
            <div className="col-span-4 row-span-4 col-start-5 row-start-1">
                <PairedUserStatisticsCard insights={insights} isLoading={isLoading} />
            </div>
        </div>
    );
};
export default UserManagementInsights;
